import { all } from 'redux-saga/effects'

import { dataSaga } from './data/saga'

export function* statisticsSaga() {
  yield all([dataSaga()])
}
